import React from 'react';
import HomeButton from './common/HomeButton';

const BannedFromParty = () => {
  return (
    <div className='onboarding-container'>
      <HomeButton />
      <div className='onboarding-card'>
        <h1>Sorry, you have been banned from this party.</h1>
      </div>
    </div>
  );
};

export default BannedFromParty;
